import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface AcceptBusinessUnitRelationReception {
  actionName: 'acceptBusinessUnitRelationReception';
  request: mtechnavi.api.company.IAcceptBusinessUnitRelationReceptionRequest;
}

export const acceptBusinessUnitRelationReception = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IAcceptBusinessUnitRelationReceptionRequest
) => {
  const execMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/AcceptBusinessUnitRelationReception';

  const result = await worker.invokeListRequest(execMethodName, {
    businessUnitManagementId: req.businessUnitManagementId,
    businessUnitManagementCode: req.businessUnitManagementCode,
    businessUnitManagementDisplayName: req.businessUnitManagementDisplayName,
  });
  return result;
};
